import { trackDashboardCtaClicked } from "analytics";
import { PATHS } from "constants/pathConstants";
import NextMoveCard from ".";
import Translate from "translate/Translate";
import { useNextMoveMemberContext } from "./useNextMoveMemberContext";

const HealthSurveyNextMoveCard = () => {
  const {
    hasCompletedEnoughOfGettingStartedSurvey,
    hasReportedCancer,
    memberNeedsToTalkToNav
  } = useNextMoveMemberContext();

  if (
    hasReportedCancer ||
    hasCompletedEnoughOfGettingStartedSurvey ||
    memberNeedsToTalkToNav
  ) {
    return null;
  }

  return (
    <NextMoveCard
      id="guided-insights-next-move"
      title={<Translate text="Answer Health Questionnaire" />}
      body={
        <>
          <Translate text="To get started, we need some information from you." />
          {" "}
          <Translate text="To request testing appropriate for you or to let us know about a cancer diagnosis, please fill out our Health Questionnaire so we can suggest the next steps you can take!" />
        </>
      }
      link={{
        onClick: () => {
          trackDashboardCtaClicked({
            workflow: "precision_guidance_survey",
            ctaLocation: "next_move_card",
            ctaId: "precision_guidance_survey"
          });
        },
        text: "Continue",
        url: PATHS.GETTING_STARTED_SURVEY
      }}
    />
  );
};

export default HealthSurveyNextMoveCard;
